import PropTypes from 'prop-types';
import React from 'react';

import './TableWrapper.scss';

const TableWrapper = ({ children }) => {
  return <div className="cp-admin-browse-home-editor-table">{children}</div>;
};

TableWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default TableWrapper;
